import {automationRulesConstants} from "../constants/automationRulesConstants";

const initialState = {
    data: {
        records: [],
        page: 0,
        recordsPerPage: 0,
        recordsReturned: 0,
        totalRecords: 0
    },
    errorMsg: "",
    isLoading: true,
    orderBy: "",
    sortBy: "",
    sortColumns: [],
    rerender: false,
    newRuleId: 0,
    rule: null,
};

const automationRulesReducer = (state = initialState, action) => {
    switch (action.type) {
        case automationRulesConstants.AUTOMATION_RULES_SET_IS_LOADING:
            return {
                ...state,
                isLoading: true,
            };
        case automationRulesConstants.AUTOMATION_RULES_STOP_LOADING:
            return {
                ...state,
                isLoading: false,
            };
        case automationRulesConstants.AUTOMATION_RULES_INFINITY_SCROLL:
            return {
                ...state,
                data: {
                    records: [...state.data.records, ...action?.result?.items],
                    page: action?.result?.page,
                    recordsPerPage: action?.result?.recordsPerPage,
                    recordsReturned: action?.result?.recordsReturned,
                    totalRecords: action?.result?.totalRecords
                },
                errorMsg: '',
                isLoading: false
            };
        case automationRulesConstants.AUTOMATION_RULES_ADD_RULE:
            return {
                ...state,
                data: {
                    ...state.data,
                    records: [
                        ...state.data.records,
                        action?.payload
                    ],
                },
                errorMsg: '',
                isLoading: false,
                rerender: true
            };
        case automationRulesConstants.AUTOMATION_RULES_DELETE_RULE:
            return {
                ...state,
                data: {
                    ...state.data,
                    records: state?.data?.records?.filter((item) => item?.id !== action?.payload?.ruleId),
                },
                errorMsg: '',
                isLoading: false
            };
        case automationRulesConstants.AUTOMATION_RULES_LOADING:
            return {
                ...state,
                data: {
                    records: action?.result?.items,
                    page: action?.result?.page,
                    recordsPerPage: action?.result?.recordsPerPage,
                    recordsReturned: action?.result?.recordsReturned,
                    totalRecords: action?.result?.totalRecords
                },
                errorMsg: '',
                isLoading: false
            };
        case automationRulesConstants.AUTOMATION_RULES_FIND_RULE:
            return {
                ...state,
                rule: action?.payload,
                errorMsg: '',
                isLoading: false
            };
        case automationRulesConstants.AUTOMATION_RULES_LOADING_ERROR:
            return {
                ...state,
                errorMsg: 'Unable to automation rules.',
                isLoading: false,
            };
        case automationRulesConstants.AUTOMATION_RULES_UPDATE_ORDER_BY:
            return {
                ...state,
                orderBy: action.orderBy
            };
        case automationRulesConstants.AUTOMATION_RULES_CLOSE_FORM:
            return {
                ...state,
                rerender: false
            };
        case automationRulesConstants.AUTOMATION_RULES_UPDATE_SORT_BY:
            return {
                ...state,
                sortBy: action.sortBy
            };
        case automationRulesConstants.AUTOMATION_RULES_UPDATE_RULE:
            return {
                ...state,
                data: {
                    ...state.data,
                    records: state?.data?.records?.map((item) => {
                        if (action?.payload?.result?.id === item?.id) {
                            return {
                                ...item,
                                name: action?.payload?.result?.name,
                                trafficSourceName: action?.payload?.trafficSourceName,
                                workspaceName: action?.payload?.workspaceName,
                                nextRunAt: action?.payload?.result?.nextRunAt,
                            };
                        }
                        return item;
                    })
                },
                isLoading: false,
                rerender: true
            };
        case automationRulesConstants.AUTOMATION_RULES_UPDATE_RULE_STATUS:
            return {
                ...state,
                data: {
                    ...state.data,
                    records: state?.data?.records?.map((item) => {
                        if (action?.payload?.ruleId === item?.id) {
                            return {
                                ...item,
                                status: action?.payload?.status ? "active" : "paused"
                            };
                        }
                        return item;
                    })
                },
                isLoading: false,
            };
        case automationRulesConstants.AUTOMATION_RULES_UPDATE_SORT_COLUMNS:
            return {
                ...state,
                sortColumns: action.sortColumns
            };
        default:
            return state;
    }
};

export default automationRulesReducer;